import styled from 'styled-components';
import { cn } from '@sglara/cn';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { InfoBox } from 'design-system/src/components/InfoBox/InfoBox';
import Banner from 'design-system/src/components/Banner/Banner';
import { sponsoredTaskCopy } from '../copy';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface BusinessRelationshipInfoBoxProps {
  /**
   * Whether the notice should appear as a vertical card (for a sidebar) or a horizontal banner (that goes across the main page content).
   *
   * Default is 'card'.
   */
  variant?: 'banner' | 'card';
  className?: string;
  customCopy?: string;
}

/**
 * A notice banner about premium drug features.
 */
export const BusinessRelationshipInfoBox = ({
  variant = 'card',
  className,
  customCopy = sponsoredTaskCopy,
}: BusinessRelationshipInfoBoxProps) => {
  const copyForRender = (
    <Container>
      {customCopy.split('\n').map((string, index) => (
        // it's safe to use the index as the key in this loop because these strings are static
        // and won't change between renders
        <div key={index}>{string}</div>
      ))}
    </Container>
  );

  if (variant === 'card') {
    return (
      <InfoBox variant="transparent" noBottomMargin noTopMargin className={className}>
        <Typography styledAs="bodyExtraSmallDMSans">{copyForRender}</Typography>
      </InfoBox>
    );
  } else {
    return <Banner variant="neutral" description={copyForRender} className={cn(className, '[&_svg]:size-4')} />;
  }
};

export default BusinessRelationshipInfoBox;
